import { IBrand } from "@faire/web-api--source/indigofair/data/IBrand";

export const getShipFromCountryForBrand = (brand: IBrand | undefined) => {
  return (
    brand?.ships_from ??
    brand?.ships_from_country ??
    brand?.ships_from_address?.country ??
    brand?.address?.country ??
    brand?.default_shipping_address?.country ??
    brand?.based_in
  );
};
